export default "data:image/webp;base64,UklGRjAAAABXRUJQVlA4TCQAAAAvJ8AFACDMNrIZ8umeQp8CgSR/wHUWCyYOA83/q//555v4Ch8="